import React from 'react'

interface HighlightTextProps {
  text: string
  highlight: string | string[]
  className?: string // 高亮样式
}

export function HighlightText({ text, highlight, className = 'text-primary' }: HighlightTextProps) {
  if (!highlight || !text) return <>{text}</>
  const highlights = Array.isArray(highlight) ? highlight.filter(Boolean) : [highlight]
  if (highlights.length === 0) return <>{text}</>
  // 构造正则，忽略大小写，转义特殊字符
  const pattern = highlights.map((h) => h.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|')
  const regex = new RegExp(`(${pattern})`, 'gi')
  const parts = text.split(regex)
  return (
    <span>
      {parts.map((part, i) =>
        highlights.some((h) => h && part.toLowerCase() === h.toLowerCase()) ? (
          <span key={i} className={className}>
            {part}
          </span>
        ) : (
          <React.Fragment key={i}>{part}</React.Fragment>
        ),
      )}
    </span>
  )
}
